var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookie__content"},[_c('CookieText',{attrs:{"text":_vm.text}}),_c('CookieLink',{attrs:{"url":_vm.url,"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }